import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";

/**
 * @function urlIsATwitchAddress Returns whether the URL is a Twitch address
 * @param url
 */
export const urlIsATwitchAddress: (url: string) => boolean = (url: string) => {

  // get the regular expression pattern for the website
  const regEx: RegExp = RegularExpressions.Twitch;

  // return the result of testing the given url against the regex pattern
  return regEx.test(url);
}
